export default __webpack_public_path__ + "static/media/Autokritigallery_6.5767fc47.jpg";